import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const Label = ({
  required,
  target,
  text,
  ...extraProps
}) =>
/*#__PURE__*/
// eslint-disable-next-line jsx-a11y/label-has-for
_jsx("label", {
  className: clsx({
    'label-required': required
  }),
  htmlFor: target,
  ...extraProps,
  children: text
});